module.exports = __webpack_public_path__ + "static/src/nrl-teams/images/bulldogs.810e9de.png";


//////////////////
// WEBPACK FOOTER
// ./src/nrl-teams/images/bulldogs.png
// module id = TnOv
// module chunks = 0